<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">DOKUMEN</span>
                <span v-else>DOCUMENTS</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Dokumen</span>
                    <span v-else>Documents</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <div class="container-fluid py-4 wow fadeInUp" data-wow-delay="0.1s">
        <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
            <div class="sub-style">
                <h4 class="sub-title px-3 mb-0 labelpmis">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">BANK DOKUMEN NUFReP</span>
                    <span v-else>NUFReP DOCUMENT BANK</span>
                </h4>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-sm-1"></div>
                <div class="col-sm-10">
                    <div class="col-sm-12 float-left pb-2">
                        <div class="input-group mb-3">
                            <input id="carikata" v-model="carikata" placeholder="Masukkan Kata Kunci Pencarian Dokumen"
                                type="text" class="form-control form-control-sm" style="font-size: small !important;"
                                @change="ambildata()">
                            <div class="input-group-append">
                                <span class="input-group-text" @click="ambildata()" style="cursor: pointer;"><i
                                        class="fas fa-search"></i></span>
                            </div>
                        </div>
                    </div>
                    <ul id="tree1" style="cursor: pointer;">
                    </ul>
                </div>
                <div class="col-sm-1"></div>
            </div>
        </div>
    </div>
    
    <Footer />
</template>

<script>
import { ref } from 'vue'
import treeview from "vue3-treeview";
import "vue3-treeview/dist/style.css";
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import xlsx from 'xlsx/dist/xlsx.full.min';
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";
import vSelect from 'vue-select';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-Regular, Arial, sans-serif" };

export default {
    components: {
        Top, Footer, swal, tree: treeview, vSelect
    },
    data() {
        return {
            halamanloading: true,
            bahasa: localStorage.getItem("bahasasistem"),
            showHuman: false,
            tampilmodal: localStorage.getItem("bookstamu"),
            capcha: this.makeid(5), capchainput: "",
            nama: '',
            hp: '',
            keperluan: '',
            ipnya: '',
            datapesan: '',
            datamaster: [],
            carikata: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovation_dokumen-File?f=',
        };
    },
    methods: {
        onlyNumberKey(evt) {
            // Only ASCII character in that range allowed
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            } return;
        },
        InisialisasiTree() {
            $.fn.extend({
                treed: function (o) {

                    var openedClass = 'fas fa-minus';
                    var closedClass = 'fas fa-plus';

                    if (typeof o != 'undefined') {
                        if (typeof o.openedClass != 'undefined') {
                            openedClass = o.openedClass;
                        }
                        if (typeof o.closedClass != 'undefined') {
                            closedClass = o.closedClass;
                        }
                    };

                    //initialize each of the top levels
                    var tree = $(this);
                    tree.addClass("tree");
                    tree.find('li').has("ul").each(function () {
                        var branch = $(this); //li with children ul
                        branch.prepend("<i class='indicator glyphicon " + closedClass + "'></i>");
                        branch.addClass('branch');
                        branch.on('click', function (e) {
                            if (this == e.target) {
                                var icon = $(this).children('i:first');
                                icon.toggleClass(openedClass + " " + closedClass);
                                $(this).children().children().toggle();
                            }
                        })
                        branch.children().children().toggle();
                    });
                    //fire event from the dynamically added icon
                    tree.find('.branch .indicator').each(function () {
                        $(this).on('click', function () {
                            $(this).closest('li').click();
                        });
                    });
                    //fire event to open branch if the li contains an anchor instead of text
                    tree.find('.branch>a').each(function () {
                        $(this).on('click', function (e) {
                            $(this).closest('li').click();
                            e.preventDefault();
                        });
                    });
                    //fire event to open branch if the li contains a button instead of text
                    tree.find('.branch>button').each(function () {
                        $(this).on('click', function (e) {
                            $(this).closest('li').click();
                            e.preventDefault();
                        });
                    });
                }
            });
            //Initialization of treeviews
            $('#tree1').treed();
            $('#treelegenda').treed();
            $('.select2').select2();

            //Initialize Select2 Elements
            $('.select2bs4').select2({
                theme: 'bootstrap4'
            });
        },
        async ambildata() {
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });

            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });
            var random = Math.random();
            await mainAPI2.get("parastapainnovationdokumen-GetDokumen?random=" + random + "&nama=" + this.carikata + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        document.getElementById("tree1").innerHTML = '';
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        for (var i = 0; i < this.datamaster.length; i++) {
                            if (this.datamaster[i].id_parent == null) {
                                if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                                    var node = document.createElement("li");
                                    node.setAttribute("id", this.datamaster[i].id);
                                    var textnode = document.createTextNode(" " + this.datamaster[i].nama + " ");

                                    if (this.datamaster[i].namajenismenu != 'Folder') {
                                        var link = document.createElement("a");
                                        var textlink = document.createTextNode(" " + this.datamaster[i].nama + " ");
                                        link.id = 'link_' + this.datamaster[i].id;

                                        if (this.datamaster[i].namajenismenu != 'Tautan') {
                                            link.href = this.folder_foto + this.datamaster[i].filenya_dokumen;
                                            link.title = this.datamaster[i].filenya_dokumen;
                                            link.setAttribute("target", "_blank");
                                        }
                                        else {
                                            link.title = this.datamaster[i].tautan;
                                            link.href = this.datamaster[i].tautan;
                                            link.setAttribute("target", "_blank");
                                        }
                                        link.appendChild(textlink);
                                        node.appendChild(link);
                                    }
                                    else {
                                        node.appendChild(textnode);
                                    }
                                }
                                else {
                                    var node = document.createElement("li");
                                    node.setAttribute("id", this.datamaster[i].id);
                                    var textnode = document.createTextNode(" " + this.datamaster[i].nama_eng + " ");

                                    if (this.datamaster[i].namajenismenu != 'Folder') {
                                        var link = document.createElement("a");
                                        var textlink = document.createTextNode(" " + this.datamaster[i].nama_eng + " ");
                                        link.id = 'link_' + this.datamaster[i].id;

                                        if (this.datamaster[i].namajenismenu != 'Tautan') {
                                            link.href = this.folder_foto + this.datamaster[i].filenya_dokumen;
                                            link.title = this.datamaster[i].filenya_dokumen;
                                            link.setAttribute("target", "_blank");
                                        }
                                        else {
                                            link.title = this.datamaster[i].tautan;
                                            link.href = this.datamaster[i].tautan;
                                            link.setAttribute("target", "_blank");
                                        }
                                        link.appendChild(textlink);
                                        node.appendChild(link);
                                    }
                                    else {
                                        node.appendChild(textnode);
                                    }
                                }


                                document.getElementById("tree1").appendChild(node);
                            }
                            else {
                                if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                                    var node = document.createElement("li");
                                    node.setAttribute("id", this.datamaster[i].id);
                                    var textnode = document.createTextNode(" " + this.datamaster[i].nama + " ");
                                    if (this.datamaster[i].namajenismenu != 'Folder') {
                                        var link = document.createElement("a");
                                        var textlink = document.createTextNode(" " + this.datamaster[i].nama + " ");
                                        link.id = 'link_' + this.datamaster[i].id;

                                        if (this.datamaster[i].namajenismenu != 'Tautan') {
                                            link.href = this.folder_foto + this.datamaster[i].filenya_dokumen;
                                            link.title = this.datamaster[i].filenya_dokumen;
                                            link.setAttribute("target", "_blank");
                                        }
                                        else {
                                            link.title = this.datamaster[i].tautan;
                                            link.href = this.datamaster[i].tautan;
                                            link.setAttribute("target", "_blank");
                                        }
                                        link.appendChild(textlink);
                                        node.appendChild(link);
                                    }
                                    else {
                                        node.appendChild(textnode);
                                    }

                                    var ul = document.createElement("ul");
                                    ul.setAttribute("id", "ul" + this.datamaster[i].id);
                                    ul.appendChild(node);
                                    //alert(this.datamaster[i].tampilpublik);
                                    if (this.datamaster[i].tampilpublik == '1') {
                                        document.getElementById(this.datamaster[i].id_parent).appendChild(ul);
                                    }
                                    
                                }
                                else {
                                    var node = document.createElement("li");
                                    node.setAttribute("id", this.datamaster[i].id);
                                    var textnode = document.createTextNode(" " + this.datamaster[i].nama_eng + " ");
                                    if (this.datamaster[i].namajenismenu != 'Folder') {
                                        var link = document.createElement("a");
                                        var textlink = document.createTextNode(" " + this.datamaster[i].nama_eng + " ");
                                        link.id = 'link_' + this.datamaster[i].id;

                                        if (this.datamaster[i].namajenismenu != 'Tautan') {
                                            link.href = this.folder_foto + this.datamaster[i].filenya_dokumen;
                                            link.title = this.datamaster[i].filenya_dokumen;
                                            link.setAttribute("target", "_blank");
                                        }
                                        else {
                                            link.title = this.datamaster[i].tautan;
                                            link.href = this.datamaster[i].tautan;
                                            link.setAttribute("target", "_blank");
                                        }
                                        link.appendChild(textlink);
                                        node.appendChild(link);
                                    }
                                    else {
                                        node.appendChild(textnode);
                                    }

                                    var ul = document.createElement("ul");
                                    ul.setAttribute("id", "ul" + this.datamaster[i].id);
                                    ul.appendChild(node);
                                    if (this.datamaster[i].tampilpublik == '1') {
                                        document.getElementById(this.datamaster[i].id_parent).appendChild(ul);
                                    }
                                }

                            }
                        }
                        $('#tree1').treed();
                    }
                    else {
                        this.datamaster = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datamaster = [];
                //console.log(error);
                this.halamanloading = false;
            });

        },
    },
    mounted() {
        this.InisialisasiTree();
        this.ambildata();
    },
}
</script>

<style></style>